import Vue from 'vue'
import './plugins/fontawesome'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router/router'

Vue.config.productionTip = false
Vue.prototype.window = window.window

new Vue({
  vuetify,
  router,
  render: h => h(App)

}).$mount('#app')
